import { ENABLER, DEFAULTS } from './constants';
import { getShouldLog } from './getShouldLog';
const getConfig = (config) => {
    const { name, fColor = DEFAULTS.FCOLOR, bColor = DEFAULTS.BCOLOR } = config;
    const queryString = window.location.search || '';
    const paramRegex = new RegExp(`${ENABLER}=([^&]*)`);
    const matches = queryString.match(paramRegex) || [];
    const paramValue = matches.length > 1 ? matches[1] : '';
    const shouldLog = getShouldLog(paramValue, name);
    return { name, fColor, bColor, shouldLog };
};
export { getConfig };
